import { render, staticRenderFns } from "./PaymentAmountWidget.vue?vue&type=template&id=17821fde&scoped=true&"
import script from "./PaymentAmountWidget.vue?vue&type=script&lang=ts&"
export * from "./PaymentAmountWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17821fde",
  null
  
)

export default component.exports